import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import i18n from '../../../../../app/i18n';

const CharacterCount = ({ characterLimit, characters }) => {
  return (
    <Counter>{`${characterLimit - characters} ${i18n.t(
      'tileForm:charactersLeft',
    )}`}</Counter>
  );
};

export default CharacterCount;

CharacterCount.propTypes = {
  characterLimit: PropTypes.number,
  characters: PropTypes.number,
};

const Counter = styled.div`
  margin-top: 0;
  margin-bottom: 10px;
  color: ${themeGet('colors.black.60')};
  font-size: 10px;
  font-weight: bold;
`;
